import {Component, Injector} from '@angular/core';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {AuthService} from '@services/auth.service';
import {LoginService} from './login.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html'
})

export class LoginComponent extends FrontendFormComponent {

    form = this._fb.group({
        email: [''],
        password: [''],
        untrusted: [false],
    });

    constructor(
        injector: Injector,
        public formService: LoginService,
        private authService: AuthService,
    ) {
        super(injector);
    }

    init() {}

    saveHandler(token) {
        this.isPending = false;
        this.authService.login(token);
    }

    /**
     * Отключаем уведомление об ошибках в полях, переопределяя родительский метод
     * @param error
     * @returns {null}
     */
    showErrorsNotification(error) {
        return null;
    }

    /**
     * Переопределим метод, чтобы разрешить отправку формы по Enter
     * @param event
     */
    onEnterPress(event) {
        /**
         * Запрещаем срабатывание Enter везде кроме Textarea
         */
        return true;
    }
}
